export type WireFrameExtractRequest = {
    /** 任务ID */
    taskId: string;
    figure_id: string;
} | {
    /** 任务ID */
    taskId: string;
    base64_image_data: string;
} | {
    /** 任务ID */
    taskId: string;
    /** 图片S3 Key */
    s3_key: string;
    /** 图片Base64数据 */
    base64_image_data?: string;
}

export interface WireFrameExtractResponse {
    wireframe_s3_key: string;
    wireframe_url: string;
    remaining_count: number;
    original_figure_id: string;
    status: number;
}

export interface WireFrameExtractApi {
    extractWireFrame(request: WireFrameExtractRequest, signal?: AbortSignal): Promise<WireFrameExtractResponse>;
}

export const WireFrameExtractApi = Symbol.for('WireFrameExtractApi');

export interface SaveWireFrameChoiceRequest {
    /** 任务ID */
    taskId: string;
    original_figure_id: string;
    /** 要保存的图形ID */
    wireframe_s3_key: string;
    /** 要保存的图形选择 */
    save_action: 'NEW_FIGURE' | 'REPLACE_ORIGINAL' | 'DISCARD';
}

export interface SaveWireFrameChoiceResponse {
    success: boolean;
    new_figure_id: string;
    message: string;
}

export interface SaveWireFrameChoiceApi {
    saveWireFrameChoice(request: SaveWireFrameChoiceRequest): Promise<SaveWireFrameChoiceResponse>;
}

export const SaveWireFrameChoiceApi = Symbol.for('SaveWireFrameChoiceApi');
